// extracted by mini-css-extract-plugin
module.exports = {"clinicFilters":"src-screens-Appointments-components-ClinicFilters-ClinicFilters-module__clinicFilters--3OrKu"};